import styled from 'styled-components'
import { FormError } from '../FormError'

export const FormErrorField = styled(FormError)`
  display: block;
  text-align: center;
  margin: 20px 0;
`
